<template>
  <m-dropdown
    class="menu-list-sorter"
    block
    :title="$t('listSorter.title')"
    :relocate-key="order.length"
    :disabled="disabled && order.length === 0"
  >
    <m-card-item
      icon="order"
      :disabled="disabled && order.length === 0"
      @click="handleOpen"
    >
      {{ $t('listSorter.title') }}
      <template #right>
        <div class="_right">
          <div v-if="order.length > 0">
            {{ order.length }}
          </div>
          <m-icon
            v-if="!(disabled && order.length === 0)"
            type="right"
            :color="$colors.grey.lighten1"
            size="11"
          />
        </div>
      </template>
    </m-card-item>
    <template #overlay>
      <m-card no-padding>
        <sorter-options
          v-if="order.length === 0 && openAsOptions"
          :sort-options="sortOptions"
          @add-sort="addSort"
        />
        <m-content
          v-else
          :padding-y="6"
          :padding-x="6"
        >
          <sorter-builder
            :style="{ minWidth: '20rem' }"
            class="_sorter-builder"
            :value="order"
            :sort-options="sortOptions"
            :disabled="disabled"
            @input="updateViewParams($event, 'order')"
          />
          <template v-if="!disabled && hasUnsavedChanges">
            <m-divider xs />
            <save-view-actions
              :views-service="viewsService"
              layout="vertical"
              :only-params="onlyParams"
            />
          </template>
        </m-content>
      </m-card>
    </template>
  </m-dropdown>
</template>

<script setup>
import SaveViewActions from '@/components/list/SaveViewActions.vue';
import SorterBuilder from '@/components/sorter/SorterBuilder.vue';
import SorterOptions from '@/components/sorter/SorterOptions.vue';
import { computed, ref } from 'vue';

const props = defineProps({
  sortOptions: {
    type: Array,
    default: () => [],
  },
  viewsService: {
    type: Object,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const openAsOptions = ref(false);

const handleOpen = () => {
  if (order.value.length === 0) {
    openAsOptions.value = true;
  }
};

const onlyParams = ['order'];
const { currentView, currentViewUnsavedChanges } = props.viewsService;
const hasUnsavedChanges = computed(() => {
  for (let i = 0; i < onlyParams.length; i++) {
    if (currentViewUnsavedChanges.value.includes(onlyParams[i])) {
      return true;
    }
  }
  return false;
});

const updateViewParams = (value, key) => {
  props.viewsService.setParams(
    currentView.value,
    {
      ...currentView.value.params,
      [key]: value,
    },
  );
};

const addSort = (option) => {
  openAsOptions.value = false;
  updateViewParams([{ ...option.value, desc: false }], 'order');
};

const order = computed(() => currentView.value.params?.order ?? []);

</script>

<style scoped lang="scss">
.menu-list-sorter {
  ._right {
    display: flex;
    gap: .4rem;
    color: $font-color-secondary
  }
}
</style>
